<template>
  <section class="organism-final-cta">
    <div class="cta-container">
      <div class="cta-content">
        <div class="cta-copy">
          <h1 class="cta-heading">Run your next job with Skyhost</h1>
          <p class="cta-description">
            Schedule a personalized demo and see how we transform your flight
            operations
          </p>
        </div>
        <div class="cta-actions">
          <Button
            variant="secondary"
            text="Get Free Trial"
            @click="openCalendly"
            class="demo-button"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Button from "@/components/atoms/Button.vue";

export default {
  name: "FinalCTA",
  components: {
    Button,
  },
  methods: {
    openCalendly() {
      window.open(
        "https://cal.com/skyhost/30min",
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
};
</script>

<style scoped>
.organism-final-cta {
  width: 100%;
  background-color: #1a1a1a;
  padding: 6rem 5rem;
  margin: 0;
}

.cta-container {
  max-width: 1400px;
  margin: 0 auto;
}

.cta-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.cta-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  flex: 1;
}

.cta-heading {
  font-size: 3rem;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
  line-height: 1.2;
}

.cta-description {
  font-size: 1.1rem;
  color: #b0b0b0;
  margin: 0;
  line-height: 1.6;
  max-width: 500px;
}

.cta-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.demo-button {
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  background-color: #fff !important;
  color: #000 !important;
  border: none !important;
  padding: 20px 40px;
  border-radius: 30px;
}

.demo-button:hover {
  background-color: #f5f5f5 !important;
}

.explore-link {
  color: #b0b0b0;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s ease;
}

.explore-link:hover {
  color: #ffffff;
}

.cta-visual {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
}

.dashboard-mockup {
  width: 100%;
  height: auto;
  max-width: 400px;
}

@media (max-width: 968px) {
  .cta-content {
    flex-direction: column;
    gap: 3rem;
    align-items: center;
    text-align: center;
  }

  .cta-copy {
    align-items: center;
  }

  .cta-actions {
    justify-content: center;
  }

  .cta-description {
    max-width: 100%;
  }

  .cta-heading {
    font-size: 2.5rem;
  }
}

@media (max-width: 768px) {
  .organism-final-cta {
    padding: 4rem 1rem;
  }

  .cta-content {
    gap: 2rem;
  }

  .cta-heading {
    font-size: 2rem;
  }

  .cta-description {
    font-size: 1rem;
  }

  .cta-actions {
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .demo-button {
    width: 100%;
    max-width: 300px;
  }

  .dashboard-mockup {
    max-width: 300px;
  }
}
</style>
